module.exports = __webpack_public_path__ + "img/clear.a2576a19.png";